module.exports = __webpack_public_path__ + "img/install-app-2.4914b08a.jpg";